import { currencyUtil } from '@/util'

export default {
  getAmount(productMoves) {
    return (productMoves.quantity * (productMoves.price * 100)) / 100
  },
  getTotalAmount(productMoves) {
    return productMoves.reduce(
      (accumulator, currentValue, currentIndex, array) => {
        const count = this.getAmount(currentValue)
        return accumulator + count
      },
      0
    )
  },
  getTotalPriceForCostAmount(productMoves) {
    return productMoves.reduce(
      (accumulator, currentValue, currentIndex, array) => {
        const count =
          !currentValue.quantity || !currentValue.priceForCostInfo
            ? ''
            : currentValue.quantity * currentValue.priceForCostInfo.cost
        return accumulator + count
      },
      0
    )
  },

  getAmountAndUnit(productMoves, currencyId) {
    const amount = this.getAmount(productMoves)
    const currency = currencyUtil.findCurrencyNameById(currencyId)

    return {
      amount: amount,
      unit: currency ? currency.unitName : ''
    }
  },
  getTotalAmountAndUnit(productMoves, currencyId) {
    const amount = this.getTotalAmount(productMoves)
    const currency = currencyUtil.findCurrencyNameById(currencyId)

    return {
      amount: amount,
      unit: currency ? currency.unitName : ''
    }
  }
}
